<div>
  <app-options-list-simple
    [trigger]="overlayTrigger"
    [actions]="assignOptions"
    (optionSelected)="onAssignOptionSelected($event)"
    [show]="isOverlayShown && showAssigneeOptions"
    (showChange)="onOverlayShowChange($event)"
  >
    <span
      (click)="onInsideClick($event)"
      #overlayTrigger="cdkOverlayOrigin"
      cdkOverlayOrigin
      class="assign-btn"
      [ngClass]="[size, !!activity?.assignee ? 'assigned' : '']"
      [appTooltip]="tooltipContent"
      tooltipPosition="top"
    >
      @if (initials) {
        <span class="initials">{{ initials }}</span>
      } @else {
        <span class="plus">+</span>
      }
      <ng-template #tooltipContent>
        @if (initials) {
          <div class="text-color-white text-center font-bold text-xs">
            {{ activity.assignee?.first_name }} {{ activity.assignee?.last_name }}
          </div>
          <div class="text-color-white text-center text-size_s font-normal">
            <!--            @if (activity.assignee?.type_id === 2) { Manager } @else { Contractor }-->
          </div>
        } @else {
          <div class="text-color-white text-center font-bold text-xs">Assign to team</div>
        }
      </ng-template>
    </span>
  </app-options-list-simple>

  <app-overlay-general
    [show]="isOverlayShown && !showAssigneeOptions"
    (showChange)="onOverlayShowChange($event)"
    [trigger]="overlayTrigger"
    [overlayPositions]="overlayPosition"
  >
    @if (isOverlayShown && !showAssigneeOptions) {
      <app-assign-teammate-table
        [projectId]="activity?.project?.id"
        (teammateSelected)="onTeammateSelected($event, activity)"
      ></app-assign-teammate-table>
    }
  </app-overlay-general>
</div>
